import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import { formatEventSubtitle } from '../../../../helpers/content';
import useDates from '../../../../hooks/useDates';
import Card from '../../../Card';
import type { SearchAllContentEventHit } from '../../types';

const SearchAllContentResultsEventHit: React.FC<{ hit: SearchAllContentEventHit }> = ({ hit }) => {
  const { t } = useTranslation();
  const { formatDate } = useDates();

  const datestring = useMemo(() => {
    if (!hit.date?.[0]) {
      return '';
    }

    const date = new Date(hit.date[0]);
    const endDate = hit.end_date?.[0] ? new Date(hit.end_date[0]) : undefined;

    return formatDate(date, endDate);
  }, [formatDate, hit.date, hit.end_date]);

  return (
    <Card
      className="SearchAllContent__Results__hit"
      url={hit.url[0]}
      label={t(`content_types.${hit.type[0]}.type`)}
      labelIcon="event"
      sublabel={datestring}
      title={<Highlight attribute="title" hit={hit} />}
      subtitle={formatEventSubtitle(hit.name, hit.location_name)}
    />
  );
};

export default SearchAllContentResultsEventHit;
